const MENU_DRAWER_CLASSNAME = "js-menu-drawer";
const MENU_DRAWER_OPEN_LINK_CLASSNAME = `${MENU_DRAWER_CLASSNAME}-clicker`;
const MENU_DRAWER_CLOSE_LINK_CLASSNAME = `${MENU_DRAWER_CLASSNAME}-close`;

class MenuDrawer {
  $body = null;
  $menuDrawerElement = null;
  drawerOpenedClassName = "is-opened";

  static menuDrawerOpenedEventName = "MenuDrawerOpened";
  static menuDrawerClosedEventName = "menuDrawerClosed";

  static attach() {
    const $menuDrawerElement = document.querySelector(`.${MENU_DRAWER_CLASSNAME}`);
    if ($menuDrawerElement) {
      /* eslint-disable-next-line no-unused-vars */
      const menuDrawer = new MenuDrawer($menuDrawerElement);
    }
  }

  constructor($menuDrawerElement) {
    this.$body = document.body;
    this.$menuDrawerElement = $menuDrawerElement;
    this.$menuDrawerOpenLink = this.$menuDrawerElement.querySelector(
      `.${MENU_DRAWER_OPEN_LINK_CLASSNAME}`
    );
    this.$menuDrawerCloseLink = this.$menuDrawerElement.querySelector(
      `.${MENU_DRAWER_CLOSE_LINK_CLASSNAME}`
    );
    this.bindEvents();
  }

  bindEvents() {
    this.$menuDrawerOpenLink.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent(MenuDrawer.menuDrawerOpenedEventName));
    });
    this.$menuDrawerCloseLink.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent(MenuDrawer.menuDrawerClosedEventName));
    });
    document.addEventListener(MenuDrawer.menuDrawerOpenedEventName, () => {
      this.$menuDrawerElement.classList.add(this.drawerOpenedClassName);
      this.$body.classList.add("show-overlay");
    });
    document.addEventListener(MenuDrawer.menuDrawerClosedEventName, () => {
      this.$menuDrawerElement.classList.remove(this.drawerOpenedClassName);
      this.$body.classList.remove("show-overlay");
    });
  }

  static triggerEvent() {
    const event = new CustomEvent(MenuDrawer.pageContentReadyEventName);
    document.dispatchEvent(event);
  }
}

export { MenuDrawer };
